import { render } from "./TourRose.vue?vue&type=template&id=aa97cf2a&scoped=true"
import script from "./TourRose.vue?vue&type=script&lang=js"
export * from "./TourRose.vue?vue&type=script&lang=js"

import "./TourRose.vue?vue&type=style&index=0&id=aa97cf2a&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa97cf2a"]])

export default __exports__